// localStorage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'speach_auth_token',
  USER_EMAIL: 'speach_user_email',
  USERNAME: 'speach_username',
  AUDIO_ENABLED: 'speach_audio_enabled',
  VIDEO_ENABLED: 'speach_video_enabled',
  AUDIO_THRESHOLD: 'speach_audio_threshold',
  AUDIO_SENSITIVITY_MODE: 'speach_audio_sensitivity_mode',
  FOCUS_HINT_SEEN: 'speach_focus_hint_seen',
  RECORDINGS: 'speach_recordings',
  AUDIO_DEVICE_ID: 'speach_audio_device_id',
  VIDEO_DEVICE_ID: 'speach_video_device_id',
} as const
